export const serverSide: boolean = typeof window === 'undefined'
export const edgeRuntime = typeof globalThis?.EdgeRuntime === 'string'
